import { connect } from 'react-redux'
import * as revenueActions from 'revenue/actions'
import type { State } from 'store/types'

import * as actions from './actions'
import ClosedReporting from './ClosedReporting'

const mapStateToProps = (state: State) => ({
  closedReportingOnlyStores: state.componentsCompleteness.closedReportingOnlyStores,
  details: state.componentsCompleteness.details,
  isFetching: state.componentsCompleteness.isFetching,
  stores: state.stores.list,
})

const mapDispatchToProps = {
  fetchStoreDetails: revenueActions.fetchStoreDetails,
  hideDetails: actions.hideDetails,
  openDetails: actions.openDetails,
}

const mergeProps = ({ closedReportingOnlyStores, stores, ...stateProps }: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  store: stores?.find((store: any) => store.storeId === stateProps.details.storeId),
  stores: closedReportingOnlyStores,
})

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ClosedReporting)
